var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tui-input"},[_c('input',{attrs:{"placeholder":_vm.placeholder,"disabled":_vm.disabled,"maxlength":"80","type":_vm.type},domProps:{"value":_vm.value},on:{"input":_setup.updateValue}})])
}
var staticRenderFns = []

export { render, staticRenderFns }